var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('dialog-form', { ref: "form", attrs: { "dialog-config": _vm.config, "form-value": _vm.value, "form-item-list": _vm.dialogItem, "form-config": _vm.formConfig }, on: { "submit": _vm.submitDialogForm } });
};
var staticRenderFns = [];

export { render, staticRenderFns };